module.exports = __webpack_public_path__ + "img/hago.c081219.jpg";